var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":_vm.toGuidePage}},[_c('img',{staticClass:"file-search",attrs:{"src":require("@/assets/images/global/file-search.png"),"alt":""}}),_c('span',[_vm._v("使用指引")])])
}
var staticRenderFns = []

export { render, staticRenderFns }